module.exports = __webpack_public_path__ + "img/sms.c2150ceb.png";